// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
// import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import App from './App'
import router from './router/index'
import store from './store/index'
//导入网络请求

import axios from './axios/index'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

import YDUI from 'vue-ydui';
import 'vue-ydui/dist/ydui.rem.css';
Vue.use(YDUI);

import $ from 'jquery'

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
import Croppa from 'vue-croppa'
Vue.use(Croppa)

Vue.prototype.getQueryString=function(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  };
  return null;
}

// //手势滑动
// var startX=0;//开始触摸的位置
// var startY=0;
// var endX=0;
// var endY=0;
// var distanceX=0;
// var distanceY=0;
// Vue.prototype.touchStart = function (ev){
//   ev = ev || event;
//
//   if(ev.touches.length == 1) {    //tounches类数组，等于1时表示此时有只有一只手指在触摸屏幕
// //              this.startX = ev.touches[0].clientX; // 记录开始位置
//
//     startX = ev.changedTouches[0].pageX;
//     startY = ev.changedTouches[0].pageY;
//   }
// };
// Vue.prototype.touchMove = function (ev){
//   ev = ev || event;
// //
// //            console.log(ev.targetTouches);
// //            console.log(ev.changedTouches);
//   endX = ev.changedTouches[0].pageX;
//   endY = ev.changedTouches[0].pageY;
//
//   distanceX = endX-startX;
//   distanceY = endY-startY;
// };
// Vue.prototype.touchEnd = function (ev) {
// //            if(ev.touches.length == 1) {
//   if (Math.abs(distanceX) > Math.abs(distanceY) && distanceX > 0) {
// //                alert('往右滑动');
//     SmartCity.goBack();
//
//   }
//
//   // else if(Math.abs(distanceX)>Math.abs(distanceY) && distanceX<0){
// //        console.log('往左滑动');
// //      }else if(Math.abs(distanceX)<Math.abs(distanceY) && distanceY<0){
// //        console.log('往上滑动');
// //      }else if(Math.abs(distanceX)<Math.abs(distanceY) && distanceY>0){
// //        console.log('往下滑动');
// //      }else{
// //        console.log('点击未滑动');
// //      }
// };

Vue.prototype.jump=function(path,arg){
  var obj={};
  obj={path:path,query:arg}
  this.$router.push(obj)
}
Vue.config.productionTip = false
//发布后是否显示提示
Vue.config.productionTip = false

//是否开启工具调试
Vue.config.devtools = process.env.NODE_ENV === 'development'

/* eslint-disable no-new */
new Vue({
  el: '#app',

  router,
  store,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js


// WEBPACK FOOTER //
// ./src/main.js